/** Petit utilitaire de construction DOM (pas de framework). */
type Child = Node | string | null | undefined | false;

export function h<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  props: Partial<Record<string, string>> & { testid?: string } = {},
  ...children: Child[]
): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);
  for (const [key, value] of Object.entries(props)) {
    if (value === undefined) continue;
    if (key === 'testid') el.dataset['testid'] = value;
    else el.setAttribute(key, value);
  }
  for (const c of children) if (c) el.append(c);
  return el;
}

export function mount(root: HTMLElement, ...children: Child[]): void {
  root.replaceChildren(...children.filter((c): c is Node | string => !!c));
}
